CIRCULAR_REMOVE